import { makeGetRequest } from 'owa-ows-gateway';
import { GetTravelAssistantDataResponse } from './GetTravelAssistantDataResponse';

const GET_USER_TRAVELASSISTANTDATA_URL: string = 'ows/api/beta/PremiumTravel';

let getTravelAssistantDataPromise: Promise<[GetTravelAssistantDataResponse]>;

export async function getTravelAssistantData(): Promise<[GetTravelAssistantDataResponse]> {
    if (!getTravelAssistantDataPromise) {
        getTravelAssistantDataPromise = makeGetRequest(GET_USER_TRAVELASSISTANTDATA_URL);
    }
    return getTravelAssistantDataPromise;
}
